import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    fontDefault: 16,
    lineHeight: ' 1.42em',
    color: colors.space75,
  },
});

export default styles;
